var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStaking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.2917V7.50002M10 2.29169L16.875 4.58335V9.92697C16.875 14.0707 13.3333 16.0417 10 17.84C6.66667 16.0417 3.125 14.0707 3.125 9.92697V4.58335L10 2.29169ZM11.25 8.54169C11.25 9.23204 10.6904 9.79169 10 9.79169C9.30964 9.79169 8.75 9.23204 8.75 8.54169C8.75 7.85133 9.30964 7.29169 10 7.29169C10.6904 7.29169 11.25 7.85133 11.25 8.54169Z",
    stroke: "#6B8299",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaking);
export default __webpack_public_path__ + "static/media/staking.3727a760316ae4099881d8f8d1ba1ef5.svg";
export { ForwardRef as ReactComponent };